import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator} from './components/sliders.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';

document.addEventListener("DOMContentLoaded", async function () {
  slickSliderGenerator('features', '.features-container');
  getSVG();
  handleDemoFormOrBot();
});
